import CustomStorage from 'utils/customStorage'
import isLocalStorageExists from 'utils/isLocalStorageExists'

export enum LocalStorageKey {
  LocalStorageUserLikeIdKey = 'sae-conversational-userlike-id',
  LocalStorageUserLikeContactIdKey = 'sae-conversational-userlike-contact-id',
}

export const storage = isLocalStorageExists()
  ? localStorage
  : new CustomStorage()
